// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M11.3214286,10.9675325 C11.8214311,11.1580097 12.2202366,11.4615781 12.5178571,
				11.8782468 C12.8154777,12.2949156 12.9642857,12.7651489 12.9642857,13.2889611
				L3.03571429,13.2889611 C3.03571429,12.4318139 3.35713964,11.7770586 4,11.3246754
				C4.23809643,11.1580079 4.82142393,10.9675336 5.75,10.7532468 C6.32143143,
				10.6818179 6.63095214,10.5270575 6.67857143,10.2889611 C6.70238107,10.1937225
				6.71428571,9.91991574 6.71428571,9.46753252 C6.71428571,9.39610359 6.69047643,
				9.33658038 6.64285714,9.28896109 C6.54761857,9.19372252 6.45238143,9.02705752
				6.35714286,8.78896109 C6.30952357,8.59848395 6.261905,8.31277252 6.21428571,
				7.93181824 C6.11904714,7.95562788 6.04166696,7.91991395 5.98214286,7.82467538
				C5.92261875,7.72943681 5.87500018,7.60443806 5.83928571,7.44967538 C5.80357125,
				7.2949127 5.78571429,7.20562788 5.78571429,7.18181824 C5.69047571,6.65800609
				5.72618964,6.40800859 5.89285714,6.43181824 C5.82142821,6.33657966 5.761905,
				6.11039145 5.71428571,5.75324681 C5.64285679,5.22943466 5.67857071,4.76515359
				5.82142857,4.36038966 C5.98809607,3.90800645 6.28571214,3.56277181 6.71428571,
				3.32467538 C7.14285929,3.08657895 7.60714036,2.97943716 8.10714286,3.00324681
				C8.58333571,3.02705645 9.01785518,3.16991216 9.41071429,3.43181824 C9.80357339,
				3.69372431 10.0714279,4.05086359 10.2142857,4.50324681 C10.3333339,4.83658181
				10.3452386,5.30086288 10.25,5.89610395 C10.2023807,6.18181966 10.1547621,
				6.36038931 10.1071429,6.43181824 C10.1785718,6.40800859 10.2321427,6.43181788
				10.2678571,6.50324681 C10.3035716,6.57467574 10.3154762,6.66396056 10.3035714,
				6.77110395 C10.2916666,6.87824734 10.279762,6.97348449 10.2678571,7.05681824
				C10.2559523,7.14015199 10.2380954,7.20562752 10.2142857,7.25324681 L10.1428571,
				7.50324681 C10.1190475,7.66991431 10.0773813,7.78896074 10.0178571,7.86038966
				C9.95833304,7.93181859 9.88095286,7.95562788 9.78571429,7.93181824 C9.738095,
				8.45563038 9.6547625,8.82467431 9.53571429,9.03896109 C9.53571429,9.06277074
				9.49404804,9.12229395 9.41071429,9.21753252 C9.32738054,9.31277109 9.28571429,
				9.37229431 9.28571429,9.39610395 L9.28571429,9.78896109 C9.28571429,10.0270575
				9.30952357,10.2056272 9.35714286,10.3246754 C9.40476214,10.4437236 9.57142714,
				10.5389607 9.85714286,10.6103897 C10.0238104,10.6818186 10.2678555,10.7413418
				10.5892857,10.7889611 C10.9107159,10.8365804 11.1547611,10.8961036 11.3214286,
				10.9675325 Z M3.96428571,10.5032468 L4.03571429,10.5032468 L3.96428571,10.5032468
				Z M3.88757781,10.5482157 L3.93179187,10.5305301 C3.91145615,10.5452451 3.88657323,
				10.5599602 3.85714286,10.5746754 L3.84421882,10.5746754 C3.85857695,10.5657843
				3.87302994,10.5569644 3.88757781,10.5482157 Z M3.84421882,10.5746754 C3.56183402,
				10.7495376 3.31614397,10.951917 3.10714286,11.1818182 C2.98809464,11.4437243
				2.90476214,11.5746754 2.85714286,11.5746754 L0,11.5746754 C0,10.8603861 0.357139286,
				10.3842004 1.07142857,10.1461039 C1.09523821,10.1461039 1.20238,10.1222947
				1.39285714,10.0746754 C1.58333429,10.0270561 1.74999929,9.97943752 1.89285714,
				9.93181824 C2.035715,9.88419895 2.1190475,9.82467574 2.14285714,9.75324681
				C2.16666679,9.68181788 2.17857143,9.49134359 2.17857143,9.18181824 C1.70237857,
				9.22943752 1.32143,9.14610502 1.03571429,8.93181824 L1.17857143,8.50324681
				C1.20238107,8.45562752 1.22619036,8.39015199 1.25,8.30681824 C1.27380964,8.22348449
				1.28571429,8.15800895 1.28571429,8.11038966 C1.30952393,7.89610288 1.32142857,
				7.56277288 1.32142857,7.11038966 C1.32142857,6.22943288 1.41666571,5.64610538
				1.60714286,5.36038966 C1.86904893,4.93181609 2.32142536,4.71753252 2.96428571,
				4.71753252 C3.94048107,4.71753252 4.49999929,5.15800431 4.64285714,6.03896109
				C4.69047643,6.25324788 4.71428571,6.56872091 4.71428571,6.98538966 L4.71428571,
				7.75324681 C4.71428571,8.01515288 4.77380893,8.30086431 4.89285714,8.61038966
				C4.98809571,8.80086681 5.02380964,8.90800859 5,8.93181824 L4.78571429,9.03896109
				C4.66666607,9.08658038 4.46428714,9.13419895 4.17857143,9.18181824 C3.98809429,
				9.18181824 3.8809525,9.19372288 3.85714286,9.21753252 L3.85714286,9.61038966
				C3.85714286,9.75324752 3.91666607,9.83658002 4.03571429,9.86038966 C4.08333357,
				9.88419931 4.17261839,9.90800859 4.30357143,9.93181824 C4.43452446,9.95562788
				4.54761857,9.98538949 4.64285714,10.0211039 C4.73809571,10.0568184 4.80952357,
				10.0984847 4.85714286,10.1461039 C4.92857179,10.2651522 4.9047625,10.3246754
				4.78571429,10.3246754 C4.45237929,10.3722947 4.20238179,10.4318179 4.03571429,
				10.5032468 L4,10.5032468 L3.93179187,10.5305301 C3.94436,10.5214357 3.95519126,
				10.5123413 3.96428571,10.5032468 C3.93842988,10.5180216 3.91286058,10.5330112
				3.88757781,10.5482157 L3.82142857,10.5746754 L3.84421882,10.5746754 Z M14.8928571,
				10.1461039 C15.6309561,10.3842004 16,10.8603861 16,11.5746754 L13.1428571,
				11.5746754 C13.0952379,11.4080079 12.9047636,11.1818197 12.5714286,10.8961039
				C12.1666646,10.5865786 11.8333346,10.4080089 11.5714286,10.3603897 L11.3928571,
				10.3603897 C11.2976186,10.3603897 11.2202384,10.348485 11.1607143,10.3246754
				C11.1011902,10.3008657 11.0833332,10.2532472 11.1071429,10.1818182 C11.1547621,
				10.1103893 11.3095225,10.0389614 11.5714286,9.96753252 C11.9285732,9.87229395
				12.1190475,9.78896145 12.1428571,9.71753252 L12.1428571,9.21753252 C11.9999993,
				9.21753252 11.7857157,9.19372324 11.5,9.14610395 C11.3571421,9.09848466
				11.2261911,9.05086609 11.1071429,9.00324681 C11.0119043,8.95562752 11.0119043,
				8.82467645 11.1071429,8.61038966 C11.1785718,8.44372216 11.238095,7.83658538
				11.2857143,6.78896109 C11.3333336,5.74133681 11.6547589,5.09848609 12.25,
				4.86038966 C12.8452411,4.62229324 13.4166639,4.65800716 13.9642857,4.96753252
				C14.4404786,5.25324824 14.6785714,5.77705252 14.6785714,6.53896109 C14.6785714,
				6.63419966 14.6726191,6.81276931 14.6607143,7.07467538 C14.6488095,7.33658145
				14.6428571,7.53896038 14.6428571,7.68181824 C14.6428571,7.82467609 14.6666664,
				8.00324574 14.7142857,8.21753252 C14.761905,8.43181931 14.8333329,8.61038895
				14.9285714,8.75324681 C15.0000004,8.87229502 15.0000004,8.94372288 14.9285714,
				8.96753252 C14.9047618,8.99134216 14.8690479,9.00324681 14.8214286,9.00324681
				C14.7738093,9.00324681 14.7380954,9.01515145 14.7142857,9.03896109 L14.2857143,
				9.14610395 C14.1904757,9.16991359 14.0357154,9.18181824 13.8214286,9.18181824
				C13.8214286,9.56277252 13.8333332,9.76515145 13.8571429,9.78896109 C13.9285718,
				9.86039002 14.0238089,9.91991324 14.1428571,9.96753252 C14.2619054,10.0151518
				14.3988088,10.0508657 14.5535714,10.0746754 C14.7083341,10.098485 14.8214282,
				10.1222943 14.8928571,10.1461039 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/People.js